export default __webpack_public_path__ + "static/media/cover-image-info.39a0741c.jpeg";